import React, {useEffect, useRef} from 'react';
import DataTable from 'datatables.net-dt';
import 'datatables.net-dt/css/dataTables.dataTables.min.css';

const UsersList = () => {
    const tableRef = useRef<HTMLTableElement>(null);

    useEffect(() => {
        if (!tableRef.current) return;

        const dt = new DataTable(tableRef.current, {
            serverSide: true,
            processing: true,
            ajax: { url: '/manage/user' },
            columns: [
                { data: 'email',          title: 'Email' },
                { data: 'requests_count', title: 'Requests Count' },
                { data: 'first_request',  title: 'First Request' },
                { data: 'last_request',   title: 'Last Request' },
                {
                    data: 'id',
                    title: '',
                    orderable: false,
                    searchable: false,
                    render: (id: number) => `<a href="/view/user/${id}">Details</a>`,
                },
            ],
            order: [[1, 'desc']],
            pageLength: 50,
            lengthMenu: [25, 50, 100],
        });

        return () => { dt.destroy(true); };
    }, []);

    return <table ref={tableRef} className="display" style={{ width: '100%' }} />;
};

export default UsersList;
